import {
    ODataHeader,
    ODataString,
    ODataDecimal,
    ODataDate,
    ODataBoolean
} from "pbas-vue-components";

import { translateProperty } from '../trans'
import store from '@/store'

const DownloadFilesHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        sortable: true,
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/DisplayName", {
            getString: function(item) {
                const lang = store.getters['common/language']
                return translateProperty(item, 'DisplayName', lang.language);
            }
        }),
        sortable: false,
        visible: true,
        searchable: true,

    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "headers.downloadcategories.path",
        type: new ODataString("Translations[]/PhysicalFile/Path", {
            getString: function(item) {
                return item.Translations.map(o=>{
                    //console.log(o);
                    return o.LanguageCode+": <a href=\""+ o.PhysicalFile.Path+"\" target=\"_blank\">"+ o.PhysicalFile.Path+"</a>"
                }).join("\n");
            },
            getHtml: (item, type) => {
                return (
                    "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 300px'>" +
                    type.getString(item, type) +
                    "</div>"
                );
            }
        }),
        sortable: false,
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/PhysicalFile/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/PhysicalFile/Name"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.category",
        type: new ODataString("Category/Translations[]/Name", {
            getString: function(item) {
                const lang = store.getters['common/language']
                return translateProperty(item.Category, 'Name', lang.language);
            }
        }),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Category/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("CategoryId"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Category/Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Category/Translations[]"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.priority",
        type: new ODataDecimal("Order"),
        sortable: true,
        version: 1,
    }),
    // new ODataHeader({
    //     title: "globals.name",
    //     type: new ODataString("Coverages[]"),
    //     sortable: false,
    //     visible: false,
    //     allowVisibilityChange: false,
    //     searchable: false
    // }),
    new ODataHeader({
        type: new ODataString("ClassDownloadFileRelations[]/DownloadFileId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        type: new ODataString("ClassDownloadFileRelations[]/ClassDownloadFileId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.class",
        type: new ODataString("ClassDownloadFileRelations[]/ClassDownloadCenterFile/Class"),
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        sortable: true,
        version: 1
    }),
    new ODataHeader({
        type: new ODataBoolean("AllowedGuest"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
];
export default DownloadFilesHeaders;